import React, { useEffect, useState } from 'react';
import { Divider } from 'components/ui';
import { wrapFunctionalComponent } from 'utils/framework';
import ShipAddressListItem from 'components/FrictionlessCheckout/DeliverToReleaseThree/ShipAddress/Section/ShipAddressListItem/ShipAddressListItem';
import orderUtils from 'utils/Order';
import TaxClaimUtils from 'utils/TaxClaim';
import addressUtils from 'utils/Address';
import { useSelector } from 'react-redux';
import { newShipAddressSelector } from 'components/FrictionlessCheckout/DeliverToReleaseThree/ShipAddress/Section/NewDefaultAddress/newDefaultAddressSelector';
import AccordionButton from 'components/FrictionlessCheckout/LayoutCard/AccordionButton';
import Debounce from 'utils/Debounce';
import { saveAndContinue } from 'services/Checkout';

const { isHalAddress } = orderUtils;

function NewDefaultAddress({
    addresses = [],
    initialSelectedId,
    isNCR = false,
    showTaxExemptAddress = false,
    taxExemptAddressLabel = '',
    removeAddressLabel = '',
    removeLabel = '',
    editAddressLabel = '',
    editLabel = '',
    buttonText,
    isSingleAddress,
    validateAddress,
    handleResponseError,
    setAnalyticsAndErrors,
    updateNcrShippingAddress,
    shippingGroupId
}) {
    const [selectedAddressId, setSelectedAddressId] = useState(initialSelectedId || (addresses[0] && addresses[0].addressId));

    const [shouldUpdateNcrShippingAddress, setShouldUpdateNcrShippingAddress] = useState(false);
    const [newShippingAddress, setNewShippingAddress] = useState(null);
    const { selectNewDefaultAddressDone, defaultAddressUpdatedDone } = useSelector(newShipAddressSelector);

    const showTaxExempt = showTaxExemptAddress && TaxClaimUtils.isTaxExemptionEnabled();

    useEffect(() => {
        handleAddressSelect(addresses[0])();
    }, []);

    useEffect(() => {
        if (shouldUpdateNcrShippingAddress) {
            updateNcrShippingAddress(newShippingAddress);
        }
    }, [shouldUpdateNcrShippingAddress, newShippingAddress]);

    const saveAndContinueDebounce = Debounce.preventDoubleClick(
        saveAndContinue(newShippingAddress, validateAddress, setAnalyticsAndErrors, handleResponseError)
    );

    const handleAddressSelect = address => () => {
        const needsUpdateNcrShippingAddress = selectNewDefaultAddressDone !== address.addressId;

        const formattedAddress = { ...address };

        const isPOBoxAddress = formattedAddress.isPOBoxAddress;
        const addressType = formattedAddress.addressType;

        delete formattedAddress.isDefault;
        delete formattedAddress.isAddressVerified;
        delete formattedAddress.formattedPhone;
        delete formattedAddress.isPOBoxAddress;
        delete formattedAddress.addressType;

        const addressData = {
            address: formattedAddress,
            isPOBoxAddress,
            addressType,
            isDefaultAddress: true,
            shippingGroupId,
            addressValidated: addressUtils.hasAVS(address.country) && address.isAddressVerified ? true : undefined
        };

        setSelectedAddressId(address.addressId);
        setNewShippingAddress(addressData);
        setShouldUpdateNcrShippingAddress(needsUpdateNcrShippingAddress);
    };

    return (
        <>
            {addresses.map((address, index) => (
                <div
                    data-at={Sephora.debug.dataAt('shippingAddress')}
                    key={address.addressId}
                >
                    <ShipAddressListItem
                        address={address}
                        isNCR={isNCR}
                        currentShipAddressId={selectedAddressId}
                        showTaxExemptAddress={showTaxExempt}
                        taxExemptAddressLabel={taxExemptAddressLabel}
                        removeAddressLabel={removeAddressLabel}
                        removeLabel={removeLabel}
                        editAddressLabel={editAddressLabel}
                        editLabel={editLabel}
                        onSelect={handleAddressSelect(address)}
                        hal={isHalAddress(address)}
                        isRadio={addresses.length > 1}
                        buttonText={buttonText}
                        labelName={'ShipAddressOptionDefaultSelection'}
                    />
                    {index < addresses.length - 1 && <Divider marginY={4} />}
                </div>
            ))}

            <AccordionButton
                marginTop={5}
                width='100%'
                onClick={saveAndContinueDebounce}
                btnText={isSingleAddress ? defaultAddressUpdatedDone : selectNewDefaultAddressDone}
            />
        </>
    );
}

export default wrapFunctionalComponent(NewDefaultAddress, 'NewDefaultAddress');
